module.exports = __webpack_public_path__ + "static/media/gearact.81cec94c.svg";